export type TripPlanningWindow = {
  isDayBased: boolean;
  isMultiDay: boolean;
  totalDays: number;
  perDayHours: number;
  activeHours: number;
};

export function tripPlanningWindow(durationHours: number): TripPlanningWindow {
  const safeHours = Number.isFinite(durationHours) ? Math.max(0.5, durationHours) : 3;
  const isDayBased = safeHours >= 24;
  const totalDays = isDayBased ? Math.max(1, Math.round(safeHours / 24)) : 1;
  const perDayHours = isDayBased ? 8 : safeHours;

  return {
    isDayBased,
    isMultiDay: totalDays > 1,
    totalDays,
    perDayHours,
    activeHours: perDayHours * totalDays,
  };
}
